/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SmsMessage { 
    id: string;
    messageType?: string;
    referenceNumber?: string;
    smsRouteName?: string;
    content?: string;
    destination?: string;
    dton: number;
    dnpi: number;
    originator?: string;
    oton: number;
    onpi: number;
    extendedParameters?: string;
    encoding?: string;
    deliveryTime?: Date;
    validityPeriod?: Date;
    destinationMessageId?: string;
    createdUtc: Date;
    attempts: number;
    lastAttemptUtc?: Date;
    clientSystemId?: string;
    keyword?: string;
    sent: boolean;
    moOperatorCode?: string;
    mtOperatorCode?: string;
    senderId?: string;
}
